import { NavItems } from "./NavItems";
import { useState } from "react";
import "./navBar.css";
import { FaBars } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { Link, NavLink } from "react-router-dom";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickClose = () => {
    setOpen(false);
  };
  const openPopup = () => {
    setShow(true);
  };
  const cloesPopup = () => {
    setShow(false);
  };

  return (
    <div className="__fw">
      <div className="__mw">
        <nav className="NavbarItems">
          <div className="Logo_wrp">
            <Link to="/">
              <img
                className="logo_img"
                src={require("../../img/logo.png")}
                alt=""
              />
            </Link>
          </div>
          <div className="Hamburger-Cross-Icons">
            {open ? (
              <IoClose color="#e5e5e5" size={27} onClick={handleClickClose} />
            ) : (
              <FaBars color="#e5e5e5" size={27} onClick={handleClickOpen} />
            )}
          </div>
          <ul className={open ? "MenuItems active" : "MenuItems"}>
            <NavLink
              to="/"
              onClick={handleClickClose}
              className={({ isActive }) => (isActive ? "nv active" : "nv")}
            >
              <li>Home</li>
            </NavLink>
            <NavLink
              to="/about"
              onClick={handleClickClose}
              className={({ isActive }) => (isActive ? "nv active" : "nv")}
            >
              <li>About Us</li>
            </NavLink>
            <NavLink
              to="/track-record"
              onClick={handleClickClose}
              className={({ isActive }) => (isActive ? "nv active" : "nv")}
            >
              <li>Track Record</li>
            </NavLink>
            <NavLink
              to="/instruments"
              onClick={handleClickClose}
              className={({ isActive }) => (isActive ? "nv active" : "nv")}
            >
              <li>Instruments</li>
            </NavLink>
            <Link to={"/contact"} className="nav-button">
              <li>Contact</li>
            </Link>
          </ul>
        </nav>
      </div>
    </div>
  );
};
export default Navbar;
